module.exports = __webpack_public_path__ + "img/scene-pulsegenerator.6dffae1c.svg";